<template>
  <CommonPages id="download" :class="['download']" :metaTitle="getMetaTitle()"
    :metaDescription="getMetaDescription()" :metaKeywords="getMetaKeyword()">
    <div class="download-apk-page">
      <div class="download-apk-page__content">
        <!-- 上半部分 - 手机和信息展示 -->
        <div class="download-apk-page__header">
          <div class="download-apk-page__info">
            <h2 class="download-apk-page__title">
              Film Plus -Free Movie & TV Show Online
            </h2>
            <div class="download-apk-page__logo">
              <img src="@/assets/ads/logo.png" alt="Film Plus Logo"
                class="download-apk-page__logo-img" />
            </div>
            <a class="download-apk-page__download-btn" :href="downloadLink" :target="downloadTarget" rel="noopener noreferrer">
              <div class="download-apk-page__download-btn-text">
                DOWNLOAD THE APP
              </div>
              <div class="download-apk-page__download-btn-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"
                  fill="none">
                  <path
                    d="M0.989728 15.0104L15.0106 0.989545M15.0106 0.989545L7.64157 0.935757M15.0106 0.989545L15.0644 8.35857"
                    stroke="black" stroke-width="1.25" />
                </svg>
              </div>
            </a>
            <div class="download-apk-page__users">
              <div class="download-apk-page__users-avatar">
                <img src="@/assets/ads/face.svg" alt="User 1"
                  class="download-apk-page__users-img" />
                <img src="@/assets/ads/face.svg" alt="User 2"
                  class="download-apk-page__users-img" />
                <img src="@/assets/ads/face.svg" alt="User 3"
                  class="download-apk-page__users-img" />
                <img src="@/assets/ads/face.svg" alt="User 4"
                  class="download-apk-page__users-img" />
              </div>
              <div class="download-apk-page__users-text">
                100 thousand+<br />
                Our users worldwide
              </div>
            </div>
          </div>
          <div class="download-apk-page__phone">
            <img src="@/assets/ads/hand.png" alt="Mobile App"
              class="download-apk-page__phone-img" />
          </div>
        </div>

        <!-- 下半部分 - 下载区域 -->
        <div class="download-apk-page__download-section">
          <div class="download-apk-page__download-title">
            Download App
          </div>
          <a class="download-apk-page__download-button" :href="downloadLink" :target="downloadTarget" rel="noopener noreferrer">
            <svg xmlns="http://www.w3.org/2000/svg" class="download-apk-page__download-icon"
              viewBox="0 0 22 24" fill="none">
              <path
                d="M1.375 21.6H20.625C21.0146 21.6 21.3411 21.715 21.6047 21.945C21.8682 22.175 22 22.46 22 22.8C22 23.14 21.8682 23.425 21.6047 23.655C21.3411 23.885 21.0146 24 20.625 24H1.375C0.985417 24 0.658854 23.885 0.395312 23.655C0.131771 23.425 0 23.14 0 22.8C0 22.46 0.131771 22.175 0.395312 21.945C0.658854 21.715 0.985417 21.6 1.375 21.6ZM11 18.45C10.7937 18.45 10.5932 18.41 10.3984 18.33C10.2036 18.25 10.0375 18.13 9.9 17.97L3.09375 10.35C2.75 9.95 2.70417 9.525 2.95625 9.075C3.20833 8.625 3.62083 8.4 4.19375 8.4H6.875V1.2C6.875 0.86 7.00677 0.575 7.27031 0.345C7.53385 0.115 7.86042 0 8.25 0H13.75C14.1396 0 14.4661 0.115 14.7297 0.345C14.9932 0.575 15.125 0.86 15.125 1.2V8.4H17.8062C18.3792 8.4 18.7917 8.625 19.0438 9.075C19.2958 9.525 19.25 9.95 18.9062 10.35L12.1 17.97C11.9625 18.13 11.7964 18.25 11.6016 18.33C11.4068 18.41 11.2063 18.45 11 18.45Z"
                fill="white" />
            </svg>
            <span>Download</span>
          </a>
          <div class="download-apk-page__mobile-container">
            <div class="download-apk-page__qr-code">
              <img src="@/assets/ads/downloadqr.png" alt="QR Code"
                class="download-apk-page__qr-img" />
            </div>
          </div>

        </div>

        <div class="download-apk-page__social-links">
          <a href="#"
            class="download-apk-page__social-link download-apk-page__social-link--telegram">
            <img src="@/assets/ads/telegram.png" alt="Telegram"
              class="download-apk-page__social-icon" />
            <div class="download-apk-page__social-text">
              Join the<br />
              Telegram Group
            </div>
          </a>
          <a href="#" class="download-apk-page__social-link download-apk-page__social-link--x">
            <img src="@/assets/ads/x.png" alt="X" class="download-apk-page__social-icon" />
            <div class="download-apk-page__social-text">
              Follow Us<br />
              on X
            </div>
          </a>
          <a href="#"
            class="download-apk-page__social-link download-apk-page__social-link--whatsapp">
            <img src="@/assets/ads/whats.png" alt="WhatsApp"
              class="download-apk-page__social-icon" />
            <div class="download-apk-page__social-text">
              Follow Us<br />
              on WhatsApp
            </div>
          </a>
          <a href="#"
            class="download-apk-page__social-link download-apk-page__social-link--instagram">
            <img src="@/assets/ads/ins.png" alt="Instagram"
              class="download-apk-page__social-icon" />
            <div class="download-apk-page__social-text">
              Follow Us<br />
              on Instagram
            </div>
          </a>
          <a href="#"
            class="download-apk-page__social-link download-apk-page__social-link--facebook">
            <img src="@/assets/ads/face.png" alt="Facebook"
              class="download-apk-page__social-icon" />
            <div class="download-apk-page__social-text">
              Follow Us<br />
              on Instagram
            </div>
          </a>
        </div>
      </div>
    </div>
  </CommonPages>
</template>

<script>
import common from '@/mixin/common.js'
import { mapGetters } from 'vuex';
import CommonPages from '@/pages/components/page_common.vue'
import '@/css/common.scss';
import '@/css/home.scss';

export default {
  name: 'DownloadApkPage',
  components: {
    CommonPages,
  },
  mixins: [common],
  computed: {
    ...mapGetters([
      'deviceType',
      'domainConfig',
    ]),
    downloadLink() {
      return this.domainConfig?.downloadUrl || '/movie-download/'
    },
    downloadTarget() {
      return this.domainConfig?.downloadUrl ? '_blank' : '_self'
    },
  },
  methods: {
    getMetaTitle () {
      console.log('11111111');
      console.log(this.domainConfig.IAmURL);
      if (!this.domainConfig || !this.domainConfig.IAmURL) {
        return `Download ${this.domainConfig?.siteName || 'Our site'} APK Safe & Fast – Hollywood, Bollywood & More`;
      }

      if (this.domainConfig.IAmURL.includes('movies123plus')) {
        return `Download 123Movies APK Safe & Fast – Hollywood, Bollywood & More`;
      }

      if (this.domainConfig.IAmURL.includes('movierulezhub')) {
        return "MovieRulz APK Free Download – No Ads, Unlimited Movie Streaming";
      }

      if (this.domainConfig.IAmURL.includes('hdxhub4u')) {
        return "HDHub4u APK Download for Android - Latest Version 2025";
      }

      if (this.domainConfig.IAmURL.includes('filmzillaxtra')) {
        return "Download Filmyzilla APK Latest Version (2025) for Free Streaming";
      }

      if (this.domainConfig.IAmURL.includes('f-moviezhub')) {
        return "Fmovies APK Free Download -Movie Downloader Free (2025 Update)";
      }

      return `Download ${this.domainConfig?.siteName || 'Our site'} APK Safe & Fast – Hollywood, Bollywood & More`;
    },
    getMetaKeyword () {
      if (!this.domainConfig || !this.domainConfig.IAmURL) {
        return `Download ${this.domainConfig?.siteName || 'Our site'} APK`;
      }

      if (this.domainConfig.IAmURL.includes('movies123plus')) {
        return `Download 123Movies APK`;
      }

      if (this.domainConfig.IAmURL.includes('movierulezhub')) {
        return "Download MovieRulz App";
      }

      if (this.domainConfig.IAmURL.includes('hdxhub4u')) {
        return "Download HDHub4u APK";
      }

      if (this.domainConfig.IAmURL.includes('filmzillaxtra')) {
        return "Filmyzilla APK Download";
      }

      if (this.domainConfig.IAmURL.includes('f-moviezhub')) {
        return "Fmovies APK Free Download";
      }

      return `Download ${this.domainConfig?.siteName || 'Our site'} APK`;
    },
    getMetaDescription () {
      if (!this.domainConfig || !this.domainConfig.IAmURL) {
        return `Download the latest version of ${this.domainConfig?.siteName || 'Our site'} APK and enjoy unlimited access to free HD movies and TV shows on your Android device. Stream or Download movies hd APK Now!`;
      }

      return `Download the latest version of ${this.domainConfig?.siteName || 'Our site'} APK and enjoy unlimited access to free HD movies and TV shows on your Android device. Stream or Download movies hd APK Now!`;
    }
  },
};
</script>

<style lang="scss">
@import '@/css/variables.scss';

.download-apk-page {
	&__content {
		display: flex;
		flex-direction: column;
		width: 100%;
		padding: 0 rem(80);
	}

	// 上半部分 - 手机和信息展示
	&__header {
		display: flex;
		flex-direction: row;
		width: 100%;
		height: rem(708);
		position: relative;
		background: url('~@/assets/ads/downlaod-bg.png') no-repeat center center;
		background-size: cover;
		border-radius: rem(24);
		border: 1px solid rgba(255, 255, 255, 0.1);
	}

	&__info {
		padding: 0 rem(80);
		display: flex;
		flex-direction: column;
		gap: rem(40);
		align-items: flex-start;
		justify-content: center;
		width: rem(542);
		box-sizing: content-box;
	}

	&__title {
		color: #ffffff;
		text-align: left;
		font-size: rem(72);
		font-style: normal;
		font-weight: 900;
		line-height: 100%; /* rem(72) */
		letter-spacing: rem(0.72);
	}

	&__logo {
		width: rem(120);
		height: rem(120);
		display: flex;
		align-items: center;
		justify-content: center;
		overflow: hidden;
	}

	&__logo-img {
		height: 100%;
	}

	&__download-btn {
		border-radius: rem(50);
		border-style: solid;
		border-color: #ffffff;
		border-width: 1px;
		padding: rem(8) rem(8) rem(8) rem(20);
		display: flex;
		flex-direction: row;
		gap: rem(12);
		align-items: center;
		justify-content: flex-start;
		text-decoration: none;
		color: inherit;
	}

	&__download-btn-text {
		color: #ffffff;
		text-align: left;
		font-family: 'Inter-SemiBold', sans-serif;
		font-size: rem(16);
		line-height: 150%;
		letter-spacing: 0.01em;
		font-weight: 600;
		text-transform: uppercase;
	}

	&__download-btn-icon {
		background: #ffffff;
		border-radius: rem(50);
		padding: rem(10);
		display: flex;
		align-items: center;
		justify-content: center;
		width: rem(36);
		height: rem(36);
	}

	&__download-btn-img {
		width: rem(20);
		height: auto;
	}

	&__users {
		display: flex;
		flex-direction: row;
		gap: rem(16);
		align-items: flex-start;
	}

	&__users-avatar {
		display: flex;
		flex-direction: row;
		align-items: center;
		width: rem(120);
		height: rem(36);
	}

	&__users-img {
		background: linear-gradient(to left, #d9d9d9, #d9d9d9);
		border-radius: 50%;
		border-style: solid;
		border-color: #ffffff;
		border-width: 2.5px;
		width: rem(36);
		height: rem(36);
		margin-right: rem(-5);
		&:not(:first-child) {
			margin-left: rem(-5);
		}
	}

	&__users-text {
		color: #ffffff;
		text-align: left;
		font-size: rem(16);
		line-height: 125%;
		font-weight: 400;
	}

	&__phone {
		position: absolute;
		right: rem(38);
		bottom: 0;
		height: rem(660);
		display: flex;
		align-items: center;
		justify-content: center;
	}

	&__phone-img {
		height: 100%;
	}

	// 下半部分 - 下载区域
	&__download-section {
		border-radius: rem(36);
		display: flex;
		flex-direction: column;
		gap: rem(44);
		align-items: center;
		background: #121212;
		margin: rem(16) auto;
		width: 100%;
		padding-top: rem(60);
	}

	&__download-title {
		background: var(--linear, linear-gradient(90deg, rgba(177, 50, 251, 1) 0%, rgba(255, 175, 0, 1) 50%, rgba(254, 50, 75, 1) 100%));
		background-clip: text;
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
		text-align: center;
		font-size: rem(60);
		line-height: rem(60);
		letter-spacing: 0.01em;
		font-weight: 800;
		width: rem(441);
		height: rem(60);
	}

	&__download-button {
		background: linear-gradient(180deg, rgba(177, 50, 251, 1) 0%, rgba(254, 50, 75, 1) 100%);
		border-radius: rem(100);
		border-style: solid;
		border-color: rgba(255, 255, 255, 0.1);
		border-width: 1px;
		display: flex;
		flex-direction: row;
		gap: rem(24);
		align-items: center;
		justify-content: center;
		width: rem(240);
		height: rem(52);
		cursor: pointer;
		text-decoration: none;
		color: inherit;

		span {
			color: #ffffff;
			text-align: left;
			font-size: rem(20);
			line-height: rem(20);
			font-weight: 700;
		}
	}

	&__download-icon {
		width: rem(22);
		height: rem(24);
	}

	&__mobile-container {
		width: rem(470);
		height: rem(452);
		position: relative;
		background: url('~@/assets/ads/mobile-qr-inside.png') no-repeat center center;
		background-size: cover;
	}

	&__qr-code {
		border-radius: rem(28);
		width: rem(200);
		height: rem(200);
		position: absolute;
		top: rem(115);
		left: 50%;
		transform: translateX(-50%);
	}

	&__qr-img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	&__feature-icon {
		width: rem(60);
		height: rem(60);
	}

	&__feature-text {
		color: #ffffff;
		text-align: left;
		font-family: 'Inter-Black', sans-serif;
		font-size: rem(16);
		line-height: rem(16);
		font-weight: 900;
		text-transform: uppercase;
	}

	&__social-links {
		display: flex;
		flex-direction: row;
		gap: rem(20);
		align-items: flex-start;
		justify-content: center;
		flex-wrap: wrap;
		margin-bottom: rem(40);
	}

	&__social-link {
		background: #000000;
		border-radius: rem(24);
		border-style: solid;
		border-color: rgba(255, 255, 255, 0.1);
		border-width: 2px;
		padding: rem(20);
		display: flex;
		flex-direction: row;
		gap: rem(16);
		align-items: center;
		justify-content: flex-start;
		width: rem(240);
		text-decoration: none;

		&--telegram {
			background: #039be5;
		}

		&--x {
			background: #000000;
		}

		&--whatsapp {
			background: #29a71a;
		}

		&--instagram {
			border: none;
			background: var(--linear, linear-gradient(45deg, rgba(255, 213, 33, 1) 0%, rgba(255, 208, 32, 1) 5.5104810744524%, rgba(254, 192, 30, 1) 12.409999966621399%, rgba(252, 167, 27, 1) 20.03999948501587%, rgba(250, 131, 22, 1) 28.209999203681946%, rgba(248, 85, 16, 1) 36.809998750686646%, rgba(245, 30, 9, 1) 45.62999904155731%, rgba(243, 0, 5, 1) 50%, rgba(242, 0, 7, 1) 50.349998474121094%, rgba(225, 0, 59, 1) 59.65999960899353%, rgba(211, 0, 103, 1) 68.79000067710876%, rgba(199, 0, 136, 1) 77.56999731063843%, rgba(191, 0, 160, 1) 85.89000105857849%, rgba(187, 0, 175, 1) 93.5699999332428%, rgba(185, 0, 180, 1) 100%));
		}

		&--facebook {
			background: #1877f2;
		}
	}

	&__social-icon {
		flex-shrink: 0;
		width: rem(44);
		height: rem(44);
	}

	&__social-text {
		color: #ffffff;
		text-align: left;
		font-family: 'Inter-Black', sans-serif;
		font-size: rem(16);
		line-height: rem(20);
		font-weight: 900;
		flex: 1;
	}

	// PC和移动端样式适配
	&.detect_deviece_pc,
	&.detect_deviece_desktop {
		// PC端特定样式
	}

	&.detect_deviece_mobile {
		// 移动端特定样式
		&__content {
			padding: 0 rem(24);
		}

		&__header {
			flex-direction: column;
			height: auto;
			padding: 0;
		}

		&__info {
			width: 100%;
			padding: rem(36) rem(24) rem(36) rem(24);
			gap: rem(24);
			box-sizing: border-box;
			align-items: flex-start;
			justify-content: flex-start;
		}

		&__title {
			font-size: rem(44);
			line-height: 100%;
			letter-spacing: 0.01em;
			font-weight: 900;
			align-self: stretch;
		}

		&__logo {
			background: #000000;
			border-radius: rem(28);
			border-width: 2px;
			border-style: solid;
			border-image: linear-gradient(135deg, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0.24) 100%);
			border-image-slice: 1;
			flex-shrink: 0;
		}

		&__download-btn {
			border-radius: rem(50);
			border-style: solid;
			border-color: #ffffff;
			border-width: 1px;
			padding: rem(8) rem(8) rem(8) rem(20);
		}

		&__download-btn-text {
			font-family: 'Inter-SemiBold', sans-serif;
			font-size: rem(16);
			line-height: 150%;
			letter-spacing: 0.01em;
			font-weight: 600;
			text-transform: uppercase;
		}

		&__download-btn-icon {
			border-radius: rem(50);
			display: flex;
			flex-direction: row;
			gap: rem(10);
			align-items: center;
			justify-content: center;
			width: rem(36);
			height: rem(36);
		}

		&__users {
			display: flex;
			flex-direction: row;
			gap: rem(16);
			align-items: flex-start;
		}

		&__users-avatar {
			display: flex;
			flex-direction: row;
			align-items: center;
		}

		&__users-img {
			background: linear-gradient(to left, #d9d9d9, #d9d9d9);
			border-radius: 50%;
			border-style: solid;
			border-color: #ffffff;
			border-width: 2.5px;
			flex-shrink: 0;
			width: rem(36);
			height: rem(36);
			position: relative;
			box-shadow: 0px 10px 15px 0px rgba(30, 215, 96, 0.08);
			object-fit: cover;

			&:not(:first-child) {
				margin-left: rem(-8);
			}
		}

		&__users-text {
			color: #ffffff;
			text-align: left;
			font-family: 'OpenSans-Regular', sans-serif;
			font-size: rem(16);
			line-height: 125%;
			font-weight: 400;
		}

		&__phone {
			position: relative;
			right: auto;
			bottom: auto;
			height: auto;
			width: 100%;
		}

		&__phone-img {
			width: 100%;
			height: auto;
		}

		&__download-section {
			padding: rem(40) rem(20);
			gap: rem(24);
		}

		&__download-title {
			font-size: rem(36);
			line-height: rem(36);
			width: auto;
			height: auto;
		}

		&__download-button {
			width: 100%;
			max-width: rem(320);
		}

		&__mobile-container {
			width: 100%;
			max-width: rem(320);
			height: auto;
			aspect-ratio: 470/452;
			background-size: contain;
		}

		&__qr-code {
			width: rem(160);
			height: rem(160);
			top: 24%;
		}

		&__social-links {
			flex-direction: column;
			gap: rem(16);
			width: 100%;
		}

		&__social-link {
			width: 100%;
		}

		&__social-text {
			white-space: normal;
		}
	}
}
</style> 